var map = {
	"./tech-apache-airflow.svg": 2117,
	"./tech-excel.svg": 2118,
	"./tech-git.svg": 2119,
	"./tech-google-sheets.svg": 2120,
	"./tech-gray-chatgpt.svg": 1334,
	"./tech-gray-excel.svg": 1335,
	"./tech-gray-git.svg": 1336,
	"./tech-gray-google-sheets.svg": 1337,
	"./tech-gray-jupyter.svg": 1338,
	"./tech-gray-multiple.svg": 1339,
	"./tech-gray-other.svg": 1340,
	"./tech-gray-powerbi.svg": 1341,
	"./tech-gray-python.svg": 1342,
	"./tech-gray-r.svg": 1343,
	"./tech-gray-sql.svg": 1344,
	"./tech-gray-tableau.svg": 1345,
	"./tech-gray-theory.svg": 1346,
	"./tech-powerbi.svg": 2121,
	"./tech-python (2).svg": 2122,
	"./tech-python.svg": 2123,
	"./tech-r.svg": 2124,
	"./tech-responsive-apache-airflow.svg": 613,
	"./tech-responsive-artificial-intelligence.svg": 546,
	"./tech-responsive-azure.svg": 614,
	"./tech-responsive-chatgpt.svg": 615,
	"./tech-responsive-copilot.svg": 616,
	"./tech-responsive-data.svg": 617,
	"./tech-responsive-excel.svg": 618,
	"./tech-responsive-git.svg": 619,
	"./tech-responsive-google-cloud.svg": 620,
	"./tech-responsive-google-sheets.svg": 621,
	"./tech-responsive-hugging-face.svg": 622,
	"./tech-responsive-jupyter.svg": 623,
	"./tech-responsive-langchain.svg": 624,
	"./tech-responsive-llama.svg": 625,
	"./tech-responsive-multiple.svg": 626,
	"./tech-responsive-powerbi.svg": 627,
	"./tech-responsive-powerpoint.svg": 628,
	"./tech-responsive-python.svg": 629,
	"./tech-responsive-r.svg": 630,
	"./tech-responsive-sql.svg": 631,
	"./tech-responsive-tableau.svg": 632,
	"./tech-responsive-theory.svg": 633,
	"./tech-sql.svg": 2125,
	"./tech-tableau.svg": 2126,
	"./tech-theory.svg": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4224;